<div class="container">
    <header>
        <div class="left">
            <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
        </div>
    
        <div class="right mobile-hide">
            <button (click)="openTaxFiguresDialog()" mat-button>Tax Figures</button>
            <a target="_blank" href="https://onlineservices.ato.gov.au/business/" mat-button>
                ATO Online Services <mat-icon>open_in_new</mat-icon>
            </a>
        </div>
    </header>
    
    <div class="container">
        <div class="tabs">
            <button [disabled]="isLoading" mat-button (click)="previousDateRange()">{{getLabel()[0]}}</button>
            <button [disabled]="isLoading" *ngIf="dateOffset > 0" mat-button (click)="nextDateRange()">{{getLabel()[1]}}</button>

            <div class="date-range-colume">
                <button mat-button [matMenuTriggerFor]="menu">{{this.dateRange.start | date}} to {{this.dateRange.end | date}}</button>
                <mat-menu #menu="matMenu">
                    <button (click)="switchToWeekly()" mat-menu-item>Weekly</button>
                    <button (click)="switchToMonthly()" mat-menu-item>Monthly</button>
                    <button (click)="switchToQuaterly()" mat-menu-item>Quaterly</button>
                    <button (click)="switchToYearly()" mat-menu-item>Yearly</button>
                </mat-menu>
            </div>
        </div>

        <div class="stats">
            <div>
                Viewing
                <p>{{info.count}}</p>
            </div>
            <div>
                Amount
                <p [apStatus]="human(info.credits)">{{info.credits | human:true}}</p>
            </div>
            <div>
                GST
                <p [apStatus]="human(info.vat)">{{info.vat | human:true}}</p>
            </div>
            <div class="filter">
                <ap-search (onChange)="search($event)" (cancelled)="searchCancelled()"></ap-search>
            </div>
        </div>

        <table class="invoices" mat-table [dataSource]="dataSource" multiTemplateDataRows>
            
            <!-- Column Headers -->
            <ng-container matColumnDef="status">
                <th class="status-header" mat-header-cell *matHeaderCellDef>Status</th>
                <td class="status-column" mat-cell *matCellDef="let transaction">
                    <div class="status" [class]="transaction.status">{{transaction.status}}</div>
                </td>
            </ng-container>
        
            <ng-container matColumnDef="date">
                <th class="date" mat-header-cell *matHeaderCellDef>Date</th>
                <td class="date" mat-cell *matCellDef="let transaction"> {{transaction['date'] | date:'dd-MM-yy'}} </td>
            </ng-container>
        
            <ng-container matColumnDef="description">
                <th class="description" mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let transaction"> {{transaction['description']}} <span class="note">{{transaction['note']}}</span></td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th class="amount" mat-header-cell *matHeaderCellDef>Amount</th>
                <td class="amount" mat-cell *matCellDef="let transaction">
                    {{ transaction['amount'] | human }}
                </td>
            </ng-container>

            <tr class="invoice-row"
                [class.evidence-selected]="selectedEvidence!=undefined"
                mat-row
                (click)="openTransactionDialog(transaction, i)"
                *matRowDef="let transaction; let i = dataIndex; columns: ['status', 'date', 'description', 'amount'];">
            </tr>
        </table>
    </div>

</div>